import { render } from "./Calcul.vue?vue&type=template&id=33b6401c"
import script from "./Calcul.vue?vue&type=script&setup=true&lang=js"
export * from "./Calcul.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Commencer/Calcul.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33b6401c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33b6401c', __exports__)) {
    api.reload('33b6401c', __exports__)
  }
  
  module.hot.accept("./Calcul.vue?vue&type=template&id=33b6401c", () => {
    api.rerender('33b6401c', render)
  })

}


export default __exports__